export default {
    methods: {
        openNewLoadingWindow() {
            const ref = window.open('/reg/loading.html', '_blank')
            ref.addEventListener("DOMContentLoaded",  ()  => {
                ref.document.title = this.$t('eventRegistration.loadingDocument')
            });

            return ref
        },
        async showContractualInfo() {
            const ref = this.openNewLoadingWindow();
            try {
                const response = await this.$axios.post(this.eventData.printViewUrl,
                    this.registrationData,
                    {responseType: 'blob'}
                )
                ref.location.href = URL.createObjectURL(response.data);
            } catch (e) {

                ref.close()
            }
        }
    }
}
